import { SVG, IconProps } from "../SVG";
import React from "react";

export const Paypal = (props: IconProps) => (
    <SVG xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" {...props}>
        <g clipPath="url(#Paypal_svg__a)">
            <path
                fill="#FFD140"
                fillRule="evenodd"
                d="M0 6a2 2 0 0 1 2-2h20a2 2 0 0 1 2 2v13a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V6Z"
                clipRule="evenodd"
            />
            <g clipPath="url(#Paypal_svg__b)">
                <path
                    fill="#003087"
                    d="M15.379 9.407c0 1.417-1.32 3.09-3.314 3.09h-1.92l-.093.59-.449 2.843h-2.39l1.436-9.155h3.871c1.302 0 2.33.721 2.705 1.723.107.284.16.589.154.91Z"
                />
                <path
                    fill="#0070E0"
                    d="M16.754 12.04a3.299 3.299 0 0 1-3.268 2.747h-1.335l-.557 3.435H9.218l.382-2.29.449-2.843.092-.589h1.92c1.994 0 3.314-1.673 3.314-3.09.982.5 1.551 1.518 1.376 2.632l.003-.003Z"
                />
                <path
                    fill="#001C64"
                    d="M15.378 9.406a3.144 3.144 0 0 0-1.452-.342h-3.24l-.541 3.436h1.92c1.993 0 3.313-1.674 3.313-3.09v-.004Z"
                />
            </g>
        </g>
        <defs>
            <clipPath id="Paypal_svg__a">
                <path fill="#fff" d="M0 0h24v24H0z" />
            </clipPath>
            <clipPath id="Paypal_svg__b">
                <path fill="#fff" d="M7 6.5h10v12H7z" />
            </clipPath>
        </defs>
    </SVG>
);
Paypal.displayName = "Paypal";
